import CryptoJS from 'crypto-js'

const AES = CryptoJS.AES
const Utf8 = CryptoJS.enc.Utf8

// 加密密钥：优先使用环境变量，其次使用默认值
const SECRET = process.env.VUE_APP_SECURE_KEY || 'fix-vue-local-secure-key-2025'

/**
 * 本地安全存储工具：在写入前加密，读取时解密
 * - 默认使用 localStorage
 * - 字符串直接加密；对象/数组会 JSON.stringify 后加密
 * - 读取时优先尝试解密，再尝试 JSON.parse；解析失败则返回原始字符串
 */
const secureStorage = {
  /**
   * 写入加密值
   * @param {string} key
   * @param {any} value - 字符串或对象
   */
  set(key, value) {
    try {
      const plain = typeof value === 'string' ? value : JSON.stringify(value)
      const cipher = AES.encrypt(plain, SECRET).toString()
      localStorage.setItem(key, cipher)
    } catch (e) {
      console.error('secureStorage.set 加密失败，改为明文写入:', e)
      try {
        const plain = typeof value === 'string' ? value : JSON.stringify(value)
        localStorage.setItem(key, plain)
      } catch (_) {
        // ignore
      }
    }
  },

  /**
   * 读取并解密
   * @param {string} key
   * @returns {any|null} 解密后的值；若无法解密且为 JSON 字符串则解析为对象
   */
  get(key) {
    const stored = localStorage.getItem(key)
    if (!stored) return null
    // 尝试解密
    try {
      const bytes = AES.decrypt(stored, SECRET)
      const plain = bytes.toString(Utf8)
      if (!plain) throw new Error('Empty decrypted result')
      // 尝试解析为 JSON
      try {
        return JSON.parse(plain)
      } catch {
        return plain
      }
    } catch (e) {
      // 若不是加密内容（旧明文），直接按原始值处理
      try {
        return JSON.parse(stored)
      } catch {
        return stored
      }
    }
  },

  /**
   * 删除键
   * @param {string} key
   */
  remove(key) {
    localStorage.removeItem(key)
  }
}

export default secureStorage
export { SECRET }
